import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_DIETS } from '../action-types'

const cleanupCommonFetchDiets = createAction(COMMON_FETCH_DIETS.CLEANUP)

export default cleanupCommonFetchDiets
